import { jsPDF } from "jspdf";

/**
 * @param {object} intelligent — réponse API (executive_summary, key_points, …)
 * @param {{ subtitle?: string, filename?: string }} [meta]
 */
export function downloadIntelligentSynthesisPdf(intelligent, meta = {}) {
  if (!intelligent) return;

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const margin = 14;
  const lineH = 5;
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const maxW = pageW - 2 * margin;
  let y = margin;

  const newPageIfNeeded = (needed = lineH) => {
    if (y + needed > pageH - margin) {
      doc.addPage();
      y = margin;
    }
  };

  const writeHeading = (text, fontSize, bold = true) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(fontSize);
    doc.setTextColor(0, 0, 0);
    newPageIfNeeded(fontSize * 0.5);
    doc.text(String(text), margin, y);
    y += fontSize * 0.45 + (bold ? 3 : 2);
  };

  const writeParagraph = (text, fontSize = 10) => {
    if (text == null || text === "") return;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(fontSize);
    doc.setTextColor(0, 0, 0);
    const lines = doc.splitTextToSize(String(text), maxW);
    lines.forEach((line) => {
      newPageIfNeeded();
      doc.text(line, margin, y);
      y += lineH;
    });
    y += 2;
  };

  writeHeading("Synthèse IA", 16, true);

  if (meta.subtitle) {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(70, 70, 70);
    const subLines = doc.splitTextToSize(String(meta.subtitle), maxW);
    subLines.forEach((line) => {
      newPageIfNeeded();
      doc.text(line, margin, y);
      y += 4.5;
    });
    doc.setTextColor(0, 0, 0);
    y += 3;
  }

  writeHeading("Synthèse direction", 12, true);
  writeParagraph(intelligent.executive_summary, 10);

  if (intelligent.key_points?.length > 0) {
    writeHeading("Points clés", 12, true);
    intelligent.key_points.forEach((t) => {
      writeParagraph(`• ${t}`, 10);
    });
  }

  if (intelligent.risks_and_priorities?.length > 0) {
    writeHeading("Risques & priorités", 12, true);
    intelligent.risks_and_priorities.forEach((t) => {
      writeParagraph(`• ${t}`, 10);
    });
  }

  if (intelligent.recommendations?.length > 0) {
    writeHeading("Recommandations", 12, true);
    intelligent.recommendations.forEach((t) => {
      writeParagraph(`• ${t}`, 10);
    });
  }

  if (intelligent.limitations) {
    newPageIfNeeded(12);
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(90, 90, 90);
    const limLines = doc.splitTextToSize(String(intelligent.limitations), maxW);
    limLines.forEach((line) => {
      newPageIfNeeded();
      doc.text(line, margin, y);
      y += 4;
    });
    doc.setTextColor(0, 0, 0);
    y += 2;
  }

  if (intelligent.model) {
    newPageIfNeeded(8);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(`Modèle : ${intelligent.model}`, margin, y);
    y += 5;
  }

  newPageIfNeeded(12);
  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  const disclaimer = doc.splitTextToSize(
    "Document produit à partir d'une synthèse automatique — à valider par un responsable HSE.",
    maxW
  );
  disclaimer.forEach((line) => {
    newPageIfNeeded();
    doc.text(line, margin, y);
    y += 4;
  });

  const rawName = meta.filename || `synthese-ia-${new Date().toISOString().slice(0, 10)}`;
  const safe = String(rawName)
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 120);
  doc.save(`${safe || "synthese-ia"}.pdf`);
}
